import { Font } from '@react-pdf/renderer'

// Single registration point for every react-pdf document (event flyer,
// group engagements). react-pdf resolves a face by exact fontStyle match
// first, then weight — so bold/light are registered both the standard way
// (fontStyle normal + numeric weight, used by eventFlyer's fontWeight: 700)
// and under the legacy style names group-engagements' fontStyle: 'bold' /
// 'light' styles look up.
Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/fonts/Roboto-Regular.ttf' },
    { src: '/fonts/Roboto-Bold.ttf', fontWeight: 700 },
    { src: '/fonts/Roboto-Bold.ttf', fontStyle: 'bold', fontWeight: 700 },
    { src: '/fonts/Roboto-Light.ttf', fontWeight: 300 },
    { src: '/fonts/Roboto-Light.ttf', fontStyle: 'light', fontWeight: 300 },
  ],
})

Font.register({
  family: 'RobotoItalic',
  fonts: [{ src: '/fonts/Roboto-Italic.ttf' }],
})

Font.register({
  family: 'RobotoCondensed',
  fonts: [{ src: '/fonts/RobotoCondensed-Bold.ttf' }],
})
